
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Button } from "@/components/ui/button"
import { SortButton } from "./SortButton"
import { SortDirection, SortField, UserProfile } from "@/types/user-management"

interface UsersTableProps {
  profiles: UserProfile[]
  sortField: SortField
  sortDirection: SortDirection
  onSort: (field: SortField) => void
  onRemoveAdmin: (userId: string) => void
}

export const UsersTable = ({
  profiles,
  sortField,
  sortDirection,
  onSort,
  onRemoveAdmin,
}: UsersTableProps) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              <SortButton
                field="name"
                label="Name"
                currentField={sortField}
                direction={sortDirection}
                onSort={onSort}
              />
            </TableHead>
            <TableHead>
              <SortButton
                field="email"
                label="Email"
                currentField={sortField}
                direction={sortDirection}
                onSort={onSort}
              />
            </TableHead>
            <TableHead>
              <SortButton
                field="industry"
                label="Industry"
                currentField={sortField}
                direction={sortDirection}
                onSort={onSort}
              />
            </TableHead>
            <TableHead>
              <SortButton
                field="role"
                label="Role"
                currentField={sortField}
                direction={sortDirection}
                onSort={onSort}
              />
            </TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {profiles?.map((profile) => (
            <TableRow key={profile.id}>
              <TableCell>{profile.name}</TableCell>
              <TableCell>{profile.email}</TableCell>
              <TableCell>{profile.industry}</TableCell>
              <TableCell className="capitalize">{profile.role}</TableCell>
              <TableCell>
                {profile.role === "admin" && (
                  <Button
                    variant="destructive"
                    size="sm"
                    onClick={() => onRemoveAdmin(profile.id)}
                  >
                    Remove Admin
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
